import CunesImg from "public/openStack/features/bxs_cube.png";
import CharmRefreshImg from "public/openStack/features/charm_refresh.png";
import UserGearImg from "public/openStack/features/fa6-solid_user-gear.png";
import LineUpImg from "public/openStack/features/lets-icons_line-up.png";
import CogRefreshImg from "public/openStack/features/mdi_cog-refresh.png";
import BillingInfoImg from "public/openStack/features/stash_billing-info.png";
import CodeImg from "public/openStack/features/tabler_code.png";
import RefreshShieldImg from "public/openStack/features/wpf_refresh-shield.png";
import SeparatorImg from "public/openStack/features/featuresSeparator.png";

export const FEATURES_CONSTANTS = {
  TITLE: "Key Features",
  ITEMS: [
    {
      image: UserGearImg,
      title: "Multi-tenant Support",
      content: "Role-based access control with comprehensive security features",
    },
    {
      image: CharmRefreshImg,
      title: "Automated Scaling",
      content: "Self-healing infrastructure with dynamic allocation",
    },
    {
      image: CunesImg,
      title: "Kubernetes Integration",
      content: "Pre-integration with Kubernetes & CI/CD pipelines",
    },
    {
      image: LineUpImg,
      title: "Full-stack Monitoring",
      content: "Comprehensive logging and cost tracking capabilities",
    },
    {
      image: CodeImg,
      title: "API-driven",
      content: "Terraform, Ansible, and CLI support included",
    },
    {
      image: BillingInfoImg,
      title: "Integrated Billing",
      content: "Built-in quota enforcement and billing management",
    },
    {
      image: CogRefreshImg,
      title: "Live Migration",
      content: "Zero-downtime upgrades and seamless transitions",
    },
    {
      image: RefreshShieldImg,
      title: "High Availability",
      content: "Redundancy and failover capabilities",
    },
  ],
  SEPARATOR_IMG: SeparatorImg,
};
